import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'

const create = async (lensId, folderName) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    lens_id: lensId,
    name: folderName
  }

  const { data } = await AxiosConfig.post(
    '/folders', 
    payload, 
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const update = async (folderId, toUpdate) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/folders/${folderId}`, 
    toUpdate, 
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const remove = async (folderId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.delete(
    `/folders/${folderId}`, 
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

export default {
  create,
  update,
  remove
}